import { render, staticRenderFns } from "./PersonalStatTile.vue?vue&type=template&id=b738f72e&scoped=true&lang=pug&"
import script from "./PersonalStatTile.vue?vue&type=script&lang=js&"
export * from "./PersonalStatTile.vue?vue&type=script&lang=js&"
import style0 from "./PersonalStatTile.vue?vue&type=style&index=0&id=b738f72e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b738f72e",
  null
  
)

export default component.exports